import RouterPathProvider from "@core/RouterPath/RouterPathProvider";
import type { TreeReadScope } from "@ext/git/core/GitCommands/model/GitCommandsModel";
import { GitTreeScopeParser } from "@ext/versioning/GitTreeScopeParser";

export const parsePathnameScope = (
	pathname: string,
): { cleanPath: string; scopeFromPathname: TreeReadScope | null } => {
	if (!pathname?.includes(":")) return { cleanPath: pathname, scopeFromPathname: null };
	const pathnameData = RouterPathProvider.parsePath(pathname);
	if (!pathnameData.catalogName?.includes(":")) return { cleanPath: pathname, scopeFromPathname: null };
	const [catalogBase, scopeStr] = pathnameData.catalogName.split(":");
	const cleanPath = RouterPathProvider.getPathname({ ...pathnameData, catalogName: catalogBase }).value;
	return { cleanPath, scopeFromPathname: GitTreeScopeParser.parse(scopeStr) };
};
